<template>
  <div>
    <p class="description mb-4">{{ competition.text }}</p>
    <div v-if="competition.type === 'APPLICATION'" class="details-container">
      <p v-if="!fieldIsEmpty(competition.subsidy)">
        <b>Támogatás mértéke:</b> {{ numberWithDots(competition.subsidy) }}
      </p>
      <p><b>Előminősítés:</b> {{ competition.preQualification ? 'Van' : 'Nincs' }}</p>
      <p v-if="competition.preQualification">
        <b>Előminősítés kezdete:</b> {{ formatDate(competition.preQualificationStart) }}
      </p>
      <p v-if="competition.preQualification">
        <b>Előminősítés vége:</b> {{ formatDate(competition.preQualificationEnd) }}
      </p>
    </div>
    <div v-if="competition.type === 'CREDIT'" class="details-container">
      <p v-if="!fieldIsEmpty(competition.creditLength)"><b>Futamidő:</b> {{ competition.creditLength }}</p>
      <p v-if="!fieldIsEmpty(competition.creditAmount)">
        <b>Hitelösszeg:</b> {{ numberWithDots(competition.creditAmount) }}
      </p>
      <p v-if="!fieldIsEmpty(competition.creditInterest)">
        <b>Kamat:</b> {{ numberWithDots(competition.creditInterest) }}
      </p>
    </div>
    <div v-if="competition.type === 'CAPITAL_PRODUCT'" class="details-container">
      <p v-if="!fieldIsEmpty(competition.capitalAmount)">
        <b>Finanszírozás összege:</b> {{ numberWithDots(competition.capitalAmount) }}
      </p>
      <p v-if="!fieldIsEmpty(competition.capitalInvestmentLength)">
        <b>Befektetés időtartama:</b> {{ competition.capitalInvestmentLength }}
      </p>
      <p v-if="!fieldIsEmpty(competition.capitalLength)"><b>Tőkealap futamideje:</b> {{ competition.capitalLength }}</p>
    </div>
    <div v-if="competition.type === 'GUARANTEE'" class="details-container">
      <p v-if="!fieldIsEmpty(competition.guaranteeCost)"><b>Éves díj:</b> {{ competition.guaranteeCost }}</p>
      <p v-if="!fieldIsEmpty(competition.guaranteeMax)">
        <b>Kezességvállalás maximuma:</b> {{ competition.guaranteeMax }}
      </p>
      <p v-if="!fieldIsEmpty(competition.guaranteeLength)">
        <b>Kezességvállalás futamideje:</b> {{ competition.guaranteeLength }}
      </p>
    </div>
    <div>
      <b-button class="col-12 col-sm-auto mt-3 mt-sm-0" variant="primary" @click="handleOfferLink(competition.link)"
        >Érdekel</b-button
      >
      <b-button
        class="col-12 col-sm-auto mt-3 mt-sm-0 ml-sm-3"
        v-if="competition.preQualification && competition.type === 'APPLICATION'"
        @click="handleOfferLink(competition.preQualificationLink)"
        >Előminősítési link</b-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: 'FavouriteCompetitionSmallDetails',
  props: ['competition'],
  methods: {
    numberWithDots(number) {
      if (!this.fieldIsEmpty(number)) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },

    formatDate: function(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('.')
    },
    handleOfferLink(link) {
      const win = window.open(link, '_blank')
      win.focus()
    },
    fieldIsEmpty: function(field) {
      return field === '' || field === null || field === undefined
    }
  }
}
</script>
<style scoped>
pre {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-size: 16px;
  color: #6f6f6f;
  white-space: pre-wrap; /* Since CSS 2.1 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
.interested-button {
  width: inherit;
}
.more-info-btn {
  background-color: #dfe6e9;
  color: #000;
  border: none;
}

.more-info-btn:hover,
.more-info-btn:active,
.more-info-btn:focus {
  background-color: #d0dadf !important;
  color: #000 !important;
  border: none;
}
</style>
